import { notification } from '../redux/notification/notificationActions'

export const errorHandler = (dispatch, type, error, payload) => {
    let message = ''
    switch (error?.response?.status) {
        case 500:
            message = 'خطا در ارتباط با سرور'
            break
        case 401:
            message = 'عدم احراز هویت'
            break
        case 400:
            message = 'ارسال داده اشتباه'
            break
        case 409:
            message = 'ارسال داده تکراری'
            break
        case 403:
            message = 'عدم دسترسی'
            break
        case 404:
            message = 'اطلاعات مورد نظر یافت نشد'
            break
        default:
            message = 'خطا در ارتباط با سرور'
    }

    dispatch({ type, payload })

    dispatch(notification({ message, variant: 'error' }))
}
